import { useEffect } from 'react';
import { useAuth } from '@clerk/react-router';
import { env } from '@/env';


export default function LoginPage(): JSX.Element {
  const { isSignedIn, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn) {
      window.location.href = '/';
      return;
    }

    const redirectUrl = `${window.location.origin}/auth/callback`;
    window.location.href = `${env.REACT_APP_CLERK_SIGN_IN_URL}?redirect_url=${encodeURIComponent(redirectUrl)}`;
  }, [isLoaded, isSignedIn]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#1B1D1F',
      color: 'white',
      fontSize: '18px',
    }}>
      <div>Redirecting to Login...</div>
    </div>
  );
}
